<template>
  <div>
    <authentication-form
      ref="authenticationForm"
      type="auto-loan"
      :with-barcode-scanner="withBarcodeScanner"
      :require-password-for-barcode-scanner="$easyscreenConfig.get('enable.loanWithoutPin') !== true"
      @authenticated="_authenticated"
      @closed="(e) => {
        if (stage === 'authentication') {
          _reEmit('closed', e);
        }
      }"
    />
    <modal-fullscreen
      ref="modal"

      colorScheme="easyscreen-menu"

      @before-open="(event) => $emit('before-open', event)"
      @opened="(event) => $emit('opened', event)"
      @before-close="(event) => $emit('before-close', event)"
      @closed="(event) => $emit('closed', event)"
    >
      <template slot="header-left">
        <easyscreen-circle-button
          icon="/images/es-menu/home_icon.png"
          icon-type="image"

          @click.native="hide"
        />
      </template>
      <template slot="header-center">
        <h1 class="easyscreen-header_1">
          {{ _l10n("Loan") }}
        </h1>
      </template>
      <template slot="content">
        <materials-scanner-sendmail
          v-if="stage === 'email-form'"
          :processed-materials-label="_l10n('Items loaned')"
          :processed-materials="_precessedMaterials().length"
          :failed-materials="_failedMaterials().length"
          :default-email="defaultEmail"
          @close="hide"
          @send="_emailReceipt"
        />
        <div style="display: none">
          <materials-scanner-loan-email-template
            ref="emailTemplate"

            :materials="_materialsToEmailTemplate()"
            :cpr="formData.cpr"
          />
        </div>

        <materials-scanner-layout v-if="stage === 'loan'">
          <template slot="header">
            {{ _l10n("Loan materials") }}
          </template>
          <template slot="content-info">
            <div
              :class="[
                'material-scanner-instruction text-center',
                { 'material-scanner-instruction_barcode': $easyscreenConfig.get('enable.selfcheckViaBarcode') },
                orientation
              ]"
            >
              <p class="es-mb-1 text-secondary">
                {{ _l10n('Place one or multiple maretials on the scanner you want to loan') }}
              </p>
              <p class="es-mb-1 text-disabled">
                {{ _l10n('Wait for the checkmark before you remove the materials') }}
              </p>

              <img
                v-if="_isLandscape()"
                class="material-scanner-instruction--image"
                :src="landscapeInstructionImage"
              />
              <img
                v-if="_isPortrait()"
                class="material-scanner-instruction--image"
                :src="portraitInstructionImage"
              />
              <p class="material-scanner-instruction_step material-scanner-instruction_step1 text-bold text-secondary">
                {{ _l10n($easyscreenConfig.get('enable.selfcheckViaBarcode') ? 'Scan the material' : 'Place material on scanner') }}
              </p>
              <p class="material-scanner-instruction_step material-scanner-instruction_step2 text-bold text-secondary">
                {{ _l10n('Wait for checkmark') }}
              </p>
              <p class="material-scanner-instruction_step material-scanner-instruction_step3 text-bold text-secondary">
                {{ _l10n('Remove items from the scanner') }}
              </p>
            </div>
          </template>
          <template slot="content-materials">
            <materials-scanner-material
              v-for="material in inventory"
              :key="material.materialId"
              :material="Object.assign({}, material.detail, material)"
              :status="_getMaterialStatus(material)"
              :message="_getMaterialMessage(material)"
              :disabled="material.disabled"
            />
          </template>
          <template slot="footer-buttons">
            <easyscreen-button-group>
              <easyscreen-button
                color="secondary"
                modificator="fixed-width_small"
                @click.native="hide"
              >
                {{ _l10n("Close without receipt") }}
              </easyscreen-button>
              <easyscreen-button
                v-if="$easyscreenConfig.get('enable.print') && _printerIsOnline()"
                color="primary"
                modificator="fixed-width_small"
                @click.native="_printReceipt"
                :disabled="_precessedMaterials().length === 0 || _inProgressMaterials().length !== 0"
              >
                {{ _l10n("Print receipt") }}
              </easyscreen-button>
              <easyscreen-button
                color="primary"
                modificator="fixed-width_small"
                @click.native="stage='email-form'"
                :disabled="_precessedMaterials().length === 0 || _inProgressMaterials().length !== 0"
              >
                {{ _l10n("Email receipt") }}
              </easyscreen-button>
            </easyscreen-button-group>
          </template>
          <template slot="footer-counter">
            <div :class="[
              'materials-scanner-counter',
              orientation
            ]">
              <p>{{ _l10n('Items loaned') }}: {{ _precessedMaterials().length }}</p>
              <p :class="{
                'text-disabled': _failedMaterials().length === 0,
                'text-danger': _failedMaterials().length !== 0
              }">{{ _l10n('Items failed') }}: {{ _failedMaterials().length }}</p>
            </div>
          </template>
        </materials-scanner-layout>
      </template>
    </modal-fullscreen>

    <modal-alert ref="alertModal" />
    <modal-confirm ref="confirmModal" />
    <modal-confirm
      ref="materialsConfirmationModal"
      @ok="() => _processMaterials( _getRequiredConfirmation() )"
      @cancel="() => _cancel( _getRequiredConfirmation() )"
    >
      <template slot="header">{{ _l10n("Loan confirmation") }}</template>
      <template slot="content">
        <div>
          {{ _l10n("You are about to loan the following") }}
          {{ _l10nPlural(_getRequiredConfirmation(), "item") }}?:
          <template v-for="loanMaterial in processingInventory">
            <div v-if="loanMaterial.requiredConfirmation" :key="loanMaterial.materialId" class="text-cursive">
              - {{ _getMaterialTitle(loanMaterial.materialId) }}
            </div>
          </template>
        </div>
      </template>
    </modal-confirm>
  </div>
</template>

<style lang="less" src="../../core/mixins.less"></style>
<style lang="less" src="../parts/instruction.less"></style>
<style lang="less" src="../parts/counter.less"></style>
<script>
  import ModalFullscreen from "../../core/modal/fullscreen.vue";
  import ModalAlert from "../../core/modal/alert.vue";
  import ModalConfirm from "../../core/modal/confirm.vue";
  import EasyscreenButton from "../../core/button/button.vue";
  import EasyscreenButtonGroup from "../../core/button/button-group.vue";
  import EasyscreenCircleButton from "../../core/button/circle-button.vue";
  import AuthenticationForm from "../../patron/authentication/authentication.vue";
  import MaterialsScannerLayout from "../parts/layout.vue";
  import MaterialsScannerMaterial from "../parts/material.vue";
  import MaterialsScannerSendmail from "../parts/sendmail.vue";
  import MaterialsScannerLoanEmailTemplate from "../email-templates/loan.vue";

  import { mapState } from "vuex";
  import * as querystring from "querystring";
  import moment from "moment";
  import lodash from "lodash";
  import { RequestError, ValidationError } from "../../../lib/errors.js";
  import l10n from "@/lib/localization/localization.js";
  import orientationMixin from "../../core/mixins/orientation.js";
  import reEmitMixin from "../../core/mixins/re-emit.js";
  import commonAPIMixin from "./common-api-mixin.js";
  import barcodeSelfcheckSupportMinix from "./barcode-selfcheck-support-minix.js";

  export default {
    name: "materials-scanner-loan",
    mixins: [reEmitMixin, orientationMixin, commonAPIMixin, barcodeSelfcheckSupportMinix],
    props: {
      withBarcodeScanner: {
        type: Boolean,
        default: true
      },
      withPrinter: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        stage: "",
        formData: {},
        userProfileData: {},
        authenticationTimestamp: null
      };
    },
    computed: {
      ...mapState({
        safetyModeEnabled: state => state.safetyModeEnabled
      }),
      defaultEmail() {
        const urlOptions = querystring.parse(window.location.href.split("#")[1]);
        return urlOptions.defaultEmail || this.userProfileData.email;
      },
      /* Proxy for modal isShown variable. */
      isShown: {
        cache: false,
        get() {
          return this.$refs.modal && this.$refs.modal.isShown;
        }
      },
      landscapeInstructionImage: {
        get() {
          if (this.$easyscreenConfig.get("enable.selfcheckViaBarcode")) {
            return "/images/scanner/loan/loan-barcode-instruction-for-landscape.png";
          }

          return "/images/scanner/loan/loan-instruction-for-landscape.png";
        }
      },
      portraitInstructionImage: {
        get() {
          if (this.$easyscreenConfig.get("enable.selfcheckViaBarcode")) {
            return "/images/scanner/loan/loan-barcode-instruction-for-portrait.png";
          }

          return "/images/scanner/loan/loan-instruction-for-portrait.png";
        }
      }
    },
    methods: {
      /* Public .show method see in ./common-api-mixin.js */
      /**
       * Hide authentication form or loan screen.
       *
       * @param {Function} callback - Called when the modal is hided.
       */
      hide(callback) {
        this.$refs.modal.hide(() => {
          this.stage = "authentication";
          this.formData = {};
          this.userProfileData = {};

          if (lodash.isFunction(callback)) {
            callback();
          }
        });
      },
      /* Proxy for localization function. */
      _l10n: l10n,
      _l10nPlural(collection, single, _plural) {
        if (!_plural) {
          _plural = single + "s";
        }

        single = l10n(single);
        _plural = l10n(_plural);

        return collection.length === 1 ? single : _plural;
      },
      /**
       * Hanlder of authenticated event for authentication-form.
       * Show the loan screen with confirmation popup if some materials on scanner.
       *
       * @param {Object} userProfileData - The user profile data.
       * @param {String} [userProfileData.email] - The user email, used for prefill email field on email receipt.
       * @param {Object} formData - The login form data.
       * @param {String} formData.cpr - The user cpr.
       * @param {String} formData.pin - The user pin.
       */
      _authenticated(userProfileData, formData) {
        this.stage = "loan";
        this.formData = formData;
        this.userProfileData = userProfileData;
        this.authenticationTimestamp = Date.now();
        this.$refs.authenticationForm.hide();
        this.$refs.modal.show(() => {
          this._showConfirmationModal();
        });
      },
      /**
       * Show the authentication form.
       */
      _show() {
        this.stage = "authentication";
        this.$refs.authenticationForm.show();
      },
      /**
       * Loan all passed materials.
       * @async
       *
       * @param {String[]} materialIds - List of material ids.
       *
       * @returns {Promise} - The promise-based callback, will be called when each material will loaned or failed.
       */
      _processMaterials(materialIds) {
        return Promise.allSettled(materialIds.map(materialId => {
          return this._loanSingle(materialId);
        }));
      },
      /**
       * Save the loan options - used in safety mode when the actual loan not possible.
       * @async
       *
       * @param {String} cpr - User cpr.
       * @param {String} pin - User pin.
       * @param {String[]} materialIds - The list of material id.
       *
       * @returns {Promise} - The promise-based callback, will be called when material will saved or failed.
       */
      async _saveLoanOperation(options) {
        await this.$easyscreenRequest.friendlyFrank.saveOperation({
          action: "loan",
          screenId: this.$easyscreenScreenId,
          cpr: options.cpr,
          pin: options.pin,
          materials: lodash.castArray(options.materialIds).filter(Boolean).map(materialId => this.fixMaterialId(materialId))
        });

        let result = {};
        options.materialIds.forEach(materialId => {
          result[materialId] = this.$l10n("Operation saved");
        });

        return result;
      },
      /**
       * Loan the single matetrial.
       * @async
       *
       * @param {String} materialId - The material id.
       *
       * @returns {Promise} - The promise-based callback, will be called when material will loaned or failed.
       */
      async _loanSingle(materialId) {
        const processingInfo = this.processingInventory[materialId];
        await this._waitMaterialForLoadingAndValidate(materialId);

        const alarmHandlingEnabled = this.$easyscreenConfig.get("enable.disableAlarmHandling") !== true &&
          this.$easyscreenConfig.get("enable.selfcheckViaBarcode") !== true;

        try {
          let loanResult = processingInfo.loanResult;
          if (!loanResult) {
            if (this.safetyModeEnabled) {
              loanResult = await this._saveLoanOperation({
                cpr: this.formData.cpr,
                pin: this.formData.pin,
                materialIds: [materialId]
              });
            } else {
              loanResult = await this.$easyscreenRequest.lmsConnector.loanMaterial({
                cpr: this.formData.cpr,
                pin: this.formData.pin === "" ? undefined : this.formData.pin,
                materialIds: [this.fixMaterialId(materialId)]
              });
            }
          }

          if (loanResult[materialId] === undefined) {
            if (loanResult.isUserBlocked) {
              throw new RequestError({
                message: `${ l10n("Account is blocked.") }<br>${ l10n("Contact the staff for more information.") }`
              });
            }

            throw new RequestError({
              message: `Loan rejected for material with id: '${ materialId }'.`
            });
          }

          if (alarmHandlingEnabled) {
            await this.$friendlyFrankScanner.setAlarm({ action: "off", materialId: materialId });
            await this.$friendlyFrankScanner.getStatus({ materialId: materialId });

            const materialInventory = this.$friendlyFrankScanner.inventory[materialId];
            if (!materialInventory || materialInventory.alarm !== "disabled") {
              throw new ValidationError({
                materialStatus: "CANCELED",
                materialMessage: l10n("Oops. you removed the material before we were able to write the alarm."
                  + " please place the item on the scanner in order to continue.")
              });
            }
          }


          processingInfo.status = "ACCEPTED";
          if (this.safetyModeEnabled) {
            processingInfo.message = loanResult[materialId];
          } else {
            const date = moment(loanResult[materialId], "YYYY-MM-DD HH:mm:ss");
            processingInfo.message = `${ l10n("Return before") }<br>${ date.format("DD&#47;MM-YYYY") }`;
          }

          processingInfo.loanResult = loanResult[materialId];

          this.$forceUpdate();
          this.$easyscreenStatistic.loanScanner({ materialId: materialId });
        } catch (error) {
          if (alarmHandlingEnabled) {
            this.$easyscreenStatistic.loanScannerFailed({ materialId: materialId });
            this.$easyscreenRequest.lmsConnector.unloanMaterial({ materialId: this.fixMaterialId(materialId) });
          }

          processingInfo.status = error.materialStatus || "REJECTED";
          processingInfo.message = error.message || error.materialMessage || `${ l10n("Item could NOT") }<br>${ l10n("be loaned") }`;

          this.$forceUpdate();

          throw error;
        }
      }
    },
    components: {
      "modal-fullscreen": ModalFullscreen,
      "modal-alert": ModalAlert,
      "modal-confirm": ModalConfirm,
      "easyscreen-button": EasyscreenButton,
      "easyscreen-button-group": EasyscreenButtonGroup,
      "easyscreen-circle-button": EasyscreenCircleButton,
      "authentication-form": AuthenticationForm,
      "materials-scanner-layout": MaterialsScannerLayout,
      "materials-scanner-material": MaterialsScannerMaterial,
      "materials-scanner-sendmail": MaterialsScannerSendmail,
      "materials-scanner-loan-email-template": MaterialsScannerLoanEmailTemplate
    }
  };
</script>
